/**
 * Позиция стрелки в поповере с помощью
 */
export enum HelpPopoverArrowPosition {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
}

export enum BrandList {
  HT_KZ = 1,
  BRONIX_UZ = 7,
  TICKETS_KZ = 100,
}

/**
 * Режими работы
 */
export enum MODE {
  /**
   * Поиск
   */
  MODE_SEARCH = 'search',
  /**
   * Страница отеля
   */
  MODE_TOUR_LIST = 'tourList',
  /**
   * Календарь цен
   */
  MODE_PRICE_CALENDAR = 'priceCalendar',
  /**
   * Режим работы ангуляра через роутинг
   */
  MODE_ROUTER = 'router',
}

/**
 * Кредитные банки
 */
export enum CREDIT_BANKS {
  HOME_BANK = 'homeCreditBank',
  KASPI_BANK = 'kaspiBank',
  ALFA_BANK = 'alfaBank',
}

export enum HotelBeachType {
  SANDY = 'Песок',
  PEBBLE = 'Галька',
  SANDY_PEBBLE = 'Песок, Галька',
}

export enum SearchParamsFindType {
  DEFAULT = 0,
  MAGNIFIER = 1,
  RECOUNT = 2,
  PRICE_CHECK = 3,
  RESERVATION = 4,
}

export enum HotelCategoryEnum {
  ECOMON = 0,
  STANDART = 1,
  PREMIUM = 2,
}

export interface CreditOptions {
  // id провайдера
  id: number;
  // банк
  bank: CREDIT_BANKS;
  // на сколько месяцев
  months: number;
  // коэффициент
  coefficient: number;
  // коэффициент для получения месячного платежа
  monthCoefficient: number;
}

(Date as any).prototype.addDays = function (days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);

  return date;
};

export class TourAirline {
  code: string;
  name: string;
  hasIcon: boolean;
}

export class TourHotelCoordinate {
  /**
   * lat широта
   */
  lat: number;
  /**
   * долгота
   */
  long: number;

  constructor(lat: number, long: number) {
    this.lat = lat;
    this.long = long;
  }
}

/**
 * Отель в туре
 */
/**
 * Страна тура
 */
export class TourCountry {
  /**
   * id страны
   */
  id?: number;
  /**
   * наименование страны
   */
  name: string;

  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}

/**
 * Регион тура
 */
export class TourRegion {
  id: any;
  name: any;

  constructor(id, name) {
    this.id = Number(id);
    this.name = name;
  }
}

/**
 * @property {id} number - id туроператора
 * @property {string} code - 2-3 символьный код. Используется, например, для вывода лого
 */
export class TourOperator {
  id: number;
  code: string;

  constructor(id: number, code: string) {
    this.id = id;
    this.code = code;
  }
}

/**
 * Комната в отеле
 * @property {string} name наименование комнаты
 * @property {string} accommodation размещение
 */
export class TourRoom {
  name: any;
  accommodation: any;

  constructor(name, accommodation) {
    this.name = name || '';
    this.accommodation = accommodation || '';
  }
}

/**
 * Питание
 * @property {string|number} id id питания
 * @property {string} name наименование питания
 * @property {string} shortName короткий код питания
 */
export class TourMeal {
  id: any;
  name: any;
  shortName: any;

  constructor(id, name, shortName) {
    this.id = id || name;
    this.name = name;
    this.shortName = shortName;
  }
}

/**
 * @property {number} adults взрослые
 * @property {number} child дети
 * @property {Array<number>} childAges возраст детей
 */
export class TourTourist {
  adults: any;
  child: any;
  childAges: any;

  constructor(adults, child, childAges = []) {
    this.adults = adults;
    this.child = child;
    this.childAges = childAges;
  }
}

/**
 * Город вылета тура
 * @property {string} name наименование
 * @property {string} nameFrom наименование (в форме откуда)
 */
export class TourDepartCity {
  id: number;
  name: string;
  nameFrom: any;

  constructor(id, name, nameFrom) {
    this.id = id;
    this.name = name;
    this.nameFrom = nameFrom;
  }
}

/**
 * Цены за тур
 * @property {number} forOne за одного
 * @property {number} forTour за тур
 * @property {number} forNight за ночь (расчет идет от одного)
 * @property {number} withoutDiscountForOne без скидки за одного
 * @property {number} withoutDiscountForTour без скидки за тур
 */
export class TourPrice {
  forOne: number;
  forNight: number;
  forTour: any;
  withoutDiscountForOne: number;
  withoutDiscountForTour: number;

  constructor(price, peopleCount, discount, nights) {
    const priceWithoutDiscount = discount ? Math.ceil(price / (1 - discount / 100)) : price;

    this.forOne = Math.floor(price / peopleCount);
    this.forNight = Math.floor(this.forOne / nights);
    this.forTour = price;
    this.withoutDiscountForOne = Math.floor(priceWithoutDiscount / peopleCount);
    this.withoutDiscountForTour = priceWithoutDiscount;
  }
}

export enum FilterTypes {
  DAYS = 'DAYS_FILTER',
  STARS = 'STARS_FILTER',
  MEALS = 'MEALS_FILTER',
  REGIONS = 'REGIONS_FILTER',
  PRICE_BOUNDS = 'PRICE_BOUNDS',
  PREMIUM = 'PREMIUM',
}

export class ChangeFilterEvent {
  targetEvent: any;
  compareValue: string;
  isActive: boolean;

  constructor(targetEvent: any, compareValue: string, isActive: boolean) {
    this.targetEvent = targetEvent;
    this.compareValue = compareValue;
    this.isActive = isActive;
  }
}

export class FilterValue {
  isActive = false;
  count: number;
  viewValue: string;
  compareValue: string;
}

export class ServiceFilter {
  type: string;
  values: FilterValue[] = [];

  constructor(type: string, values: FilterValue[] = []) {
    this.type = type;
    this.values = values;
  }
}

export enum TourInclude {
  FLIGHT = 'flight',
  TRANSFER = 'transfer',
  HOTEL = 'hotel',
  MEAL = 'meal',
  INSURANCE = 'insurance',
  TOUR_CODE = 'tourCode',
}

export interface IChangeSort {
  attribute: string;
  direction: string;
  isShowPrice: boolean;
}

/**
 * Параметры по туристам
 */
export interface ITouristsParams {
  splitRooms: boolean;
  adult: number;
  child: number;
  childAges: number[];
}


export interface ISearchOptions {
  city_id?: any;
  findType: SearchParamsFindType;
  calcRelations?: boolean;
  paramsFromResultId?: boolean;
  saveParsers: boolean;
  params: any;
  fromDb?: boolean;
  pages?: number;
  actID: any;
  reqHash: string;
  splitRooms: boolean;
}

export interface SuggestHotelCountry {
  id: number;
  name: string;
}

export interface SuggestHotelRegion {
  id: number;
  name: string;
}

export interface SuggestHotel {
  id: number;
  name: string;
  country: SuggestHotelCountry;
  region: SuggestHotelRegion;
}

export interface HotelRecommendation {
  text: string;
  type: string;
}

/**
 * Параметры формы поиска
 */
export interface SearchFormParams {
  adult: number;
  child: number;
  childAges: number[];
  country: number;
  departCity: number;
  dateFrom: string;
  dateTo: string;
  hotelType: string;
  hotels: number[];
  nightsFrom: number;
  nightsTo: number;
  priceMax: string;
  priceMin: string;
  region: string;
  regionIds: string;
  stars: string;
  starsList: string;
  meals: string;
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortDirectionVariant {
  PRICE = 'price.forOne',
  POPULARITY = 'hotel.popularity',
  WRATING = 'wrating',
}

export enum SortDirectionVariantCode {
  PRICE_ASC = 'price.forOne:asc',
  PRICE_DESC = 'price.forOne:desc',
  POPULARITY_ASC = 'hotel.popularity:asc',
  POPULARITY_DESC = 'hotel.popularity:desc',
  RATING_ASC = 'rating:asc',
  RATING_DESC = 'rating:desc',
  WRATING_ASC = 'wrating:asc',
  WRATING_DESC = 'wrating:desc',
  BY_PRICE_QUALITY_ASC = 'price_quality:asc',
  BY_PRICE_QUALITY_DESC = 'price_quality:desc',
}

export enum AutoTypesRecommendation {
  SALES_RECOMMENDATION_TYPE = 'sales',
  BAYES_RECOMMENDATION_TYPE = 'bayes',
}

export enum HTTPSort {
  BY_PRICE = 'price',
  BY_SALES = '-sales',
  BY_RATING = 'rating',
  BY_WRATING = 'wrating',
  BY_PRICE_QUALITY = 'price_quality',
  BY_COMMISSION_PER_CLICK = 'commission_per_click',
  BY_COMMISSION_PER_VIEW = 'commission_per_view',
  BY_ONLINE_SALES = 'online_sales',
  BY_BOOKING_POSITION = 'booking_position',
  BY_MANAGER_OFFER = 'manager_offer',
}

export enum HTTPFilterPillType {
  SORT = 'sort',
  PRICE = 'price',
  TAGS = 'tags',
  STARS = 'stars',
  RATINGS = 'ratings',
  SEA_LINES = 'seaLines',
  BEACH_TYPES = 'beachTypes',
  MEAL_IDS = 'mealIds',
  REGIONS_IDS = 'regionsIds',
  AIRLINES = 'airlines',
  NIGHTS_LIST = 'nightsList',
  HOTEL_SERVICES = 'hotelServices',
  ONLY_RECOMMENDED_HOTELS = 'onlyRecommendedHotels',
  ONLY_SMART = 'onlySmart',
}

export interface HTTPSearchRequest {
  params: HTTPSearchParams;
  ukey: string;
  bkey: string;
  type: SearchParamsFindType;
}

export interface HTTPSearchParams {
  adults: number;
  dateFrom: string;
  dateTo: string;
  nightsFrom?: number;
  nightsTo?: number;
  countryId: number;
  departCityId?: number;
  airlines?: string[];
  childAges?: number[];
  combined?: number;
  currency?: string;
  enableLog?: boolean;
  groupMode?: number;
  hotels?: number[];
  meals?: number[];
  notGDS?: boolean;
  onlyHotels?: boolean;
  operators?: number[];
  priceMax?: number;
  priceMin?: number;
  regions?: number[];
  sort?: string;
  stars?: number[];
}

export interface HTTPSearchResponse {
  id: string;
  timeout: number;
  error?: string;
}

export interface HTTPSearchPostFilterResponse {
  timeout: number;
  message?: string;
}

export interface HTTPSearchResult {
  searchIsDone: boolean;
  total: number;
  pages: number;
  tours: HTTPSearchResultTour[];
  error?: string;
}

export interface HTTPRecommendationsResult {
  tours: HTTPSearchResultRecommendedTour[];
}

export interface HTTPTourPrice {
  value: number;
  currency: string;
}

export interface HTTPTourAirline {
  code: string;
  name: string;
  hasIcon: boolean;
}

export interface HTTPSearchResultTour {
  adults: number;
  airlines: HTTPTourAirline[];
  childAges?: number[];
  beachType?: string;
  bookingReviewsCount: number;
  country: string;
  dateFrom: string;
  departCity: string;
  departCityFrom: string;
  discount?: number;
  hotelClass: string;
  hotelId: number;
  hotelName: string;
  hotelServices?: string[];
  id: string;
  isCombined: boolean;
  isRecommended: boolean;
  meal: string;
  nights: number;
  photo: string;
  photosCount: number;
  price: HTTPTourPrice;
  rating: number;
  htRating: number;
  region: string;
  reviewsCount: number;
  room: string;
  salesCount?: number;
  seaLine: number;
  stars: number;
}

export interface HTTPSearchResultFilter {
  filterKey: string;
  name: string;
  values: HTTPSearchResultFilterValue[];
}
export interface HttpSearchResultFilterPrices {
  min: HTTPTourPrice,
  max: HTTPTourPrice,
  step?: number,
}
export interface HTTPSearchResultFilterValue {
  count: number;
  filterValue: string;
  minPrice: number;
  viewValue: string;
}
export interface HTTPSearchResultFiltersResponse {
  total: number;
  prices?: HttpSearchResultFilterPrices;
  filters: HTTPSearchResultFilter[];
}

export interface HttpSearchResultTagsRequest {
  bestHotelOnly?: boolean;
  limit?: number
}

export interface HttpSearchResultTagsResponse {
  isDone: boolean;
  tags: HttpSearchResultTag[]
}

export interface HTTPSearchResultFilters {
  airlines: { [key: string]: HTTPSearchResultFilter };
  beaches: { [key: string]: HTTPSearchResultFilter };
  hotel_services: { [key: string]: HTTPSearchResultFilter };
  meals: { [key: string]: HTTPSearchResultFilter };
  nights: { [key: string]: HTTPSearchResultFilter };
  ratings: { [key: string]: HTTPSearchResultFilter };
  regions: { [key: string]: HTTPSearchResultFilter };
  sea_lines: { [key: string]: HTTPSearchResultFilter };
  stars: { [key: string]: HTTPSearchResultFilter };
}

export interface HTTPSearchResultHotelViewCount {
  hotelId: number;
  count: number;
}

export interface HTTPSearchResultTourMap {
  adults: number;
  children?: number;
  childAges?: number[];
  date: string;
  hotel: string;
  hotelId: number;
  id: string;
  lat: number;
  long: number;
  nights: number;
  photo: string;
  price: HTTPTourPrice;
  rating: number;
  stars: number;
  hotelClass: number;
  region: string;
  bookingReviewsCount: number;
}

export interface StateFilters {
  airlines: string[];
  beachTypes: string[];
  datesList: string[];
  hotelServices: string[];
  hotelsIds: number[];
  mealIds: string[];
  nightsList: string[];
  ratings: number[];
  regionsIds: string[];
  seaLines: number[];
  stars: string[];
  priceMax?: number;
  priceMin?: number;
  smartfilters: StateSmartFilters;
  onlyRecommendedHotels: boolean;
  onlySmart: boolean;
}
export interface StateAviaFilters {
  price: {from:string, to: string};
  airlines: string[];
  originAirports: string[];
  destinationAirports: string[];
  flightType: string;
  stops: string;
  stopoverDuration: string;
  departureTimeFromOrigin: {from:string, to: string};
  departureTimeFromDestination: {from:string, to: string};
  baggageOnly: boolean;
  withoutNightStopovers: boolean;
}

export interface StateSmartFilters {
  bestHotelOnly?: boolean;
  selectMode: number;
  tagsIds: number[];
}

export interface HttpSearchResultTag {
  forms: string[];
  id: number;
  name: string;
  useCount: number;
  usePercent: number;
}

export interface State {
  page: number;
  size: number;
  sort: string;
  groupMode: number;
  selectedFiltersCount: number;
  applyedFiltersCount: number;
  selectedFilters: StateFilters;
  applyedFilters: StateFilters;
}

export interface ChangedFilterEvent {
  event: any;
  selectedCount: number;
  applyedCount: number;
  onlySmartFilter?: boolean;
}

export interface PostFilterParams {
  searchId: string;
  timeout: number;
}

export interface HTTPSearchResultRecommendedTour {
  adults: number;
  childAges?: number[];
  reviewsCount: number;
  bookingReviewsCount: number;
  country: string;
  hotelId: number;
  hotelName: string;
  id: string;
  photo: string;
  price: HTTPTourPrice;
  rating: number;
  region: string;
  stars: number;
  recommendationType: string;
}

export interface SearchChunkState {
  searchId: string;
  toursChunkCount: number;
  isDone: boolean;
}

export interface NearDatesWithPrice {
  date: string;
}

export interface WishlistResponse {
  success: boolean;
  message?: string;
}

export interface WishlistHotelsResponse {
  success: boolean;
  message?: string;
  hotelIds: number[];
}
